import { useState } from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import "./DesktopLayout.css";

const DesktopLayout = () => {

  const [sidebarContent, setSidebarContent] = useState(null);
  const { user } = useSelector((state) => state.auth);

  const handleContentChange = (content) => {
    setSidebarContent(content);
  };

  return (
    <div className="d-flex" style={{ height: "100vh", overflow: "hidden" }} key={user?.id || "guest"}>

      <Sidebar onContentChange={handleContentChange} />

      <main className="flex-grow-1 d-flex flex-column" style={{ overflowY: "auto", overflowX: "hidden", minWidth: 0, backgroundColor: "var(--bg-main)" }}>
        
        <Outlet />
        
        {sidebarContent && <div className="sidebar-extra">{sidebarContent}</div>}
      </main>

    </div>
  );
};

export default DesktopLayout;